import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faBrain,
  faCheck,
  faCircleInfo,
  faDriversLicense,
  faFileAlt,
  faLock,
  faMortarBoard,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useWizardFormContext } from 'providers/WizardFormProvider';
import { Nav } from 'react-bootstrap';

const WizardNavItem = ({
  icon,
  label,
  step
}: {
  icon: IconProp;
  label: string;
  step: number;
}) => {
  const { selectedStep, totalStep } = useWizardFormContext();
  return (
    <Nav.Item as="li" className="nav-item">
      <Nav.Link
        className={classNames('fw-semibold', {
          done: selectedStep > step && step !== totalStep,
          complete: selectedStep > step && step !== totalStep - 1
        })}
        eventKey={step}
      >
        <div className="text-center d-inline-block">
          <span className="nav-item-circle-parent">
            <span className="nav-item-circle">
              <FontAwesomeIcon icon={icon} />
            </span>
          </span>
          <span className="d-none d-md-block mt-1 fs-9">{label}</span>
        </div>
      </Nav.Link>
    </Nav.Item>
  );
};

const NSWizardNav = () => {
  return (
    <Nav className="justify-content-between nav-wizard">
      <WizardNavItem icon={faDriversLicense} step={1} label="Information" />
      <WizardNavItem icon={faBrain} step={2} label="NeuroSkill" />
      <WizardNavItem icon={faMortarBoard} step={3} label="Knowledge" />
      <WizardNavItem icon={faCheck} step={4} label="Register" />
    </Nav>
  );
};

export default NSWizardNav;
